import { AppState, AuthorPageAntalyaAppState } from '../../../initialStateRegistration';
import { AuthorPageSectionName } from '../authorPage.reducer';

const getAuthorPage = (state: AppState) => (state as AuthorPageAntalyaAppState).template;

export const getImage = (state: AppState) => getAuthorPage(state).image;

export const getName = (state: AppState) => getAuthorPage(state).name;

export const getSocialButtons = (state: AppState) => getAuthorPage(state).socialButtons;

export const getBio = (state: AppState) => getAuthorPage(state).bio;

export const getJoinDate = (state: AppState) => getAuthorPage(state).joinDate;

const getAuthorPageSection = (state: AppState) => getAuthorPage(state)[AuthorPageSectionName];

export const getArticles = (state: AppState) => getAuthorPageSection(state).articles;

export const getShowMorePaginationURLByKey = (key: typeof AuthorPageSectionName) => (state: AppState) => getAuthorPage(state)[key].showMorePaginationURL;

export const getShowMorePaginationText = (state: AppState) => getAuthorPageSection(state).showMorePaginationText;

export const getJoinDateText = (state: AppState) => getAuthorPage(state).joinDateText;

export const getMetadataTitle = (state: AppState) => getAuthorPage(state).metadataTitle;

export const getMetadataDescription = (state: AppState) => getAuthorPage(state).metadataDescription;

export const getMetadataImage = (state: AppState) => getAuthorPage(state).metadataImage;
